import React, { useEffect, useState } from "react";
import API_BASE_URL from "../Config.js";
import "../styles/Table.css"; // Table 스타일

function ManagerList() {
    // 컴포넌트 내부 상단에 추가
    const [editingId, setEditingId] = useState(null); 
    const [users, setUsers] = useState([]);
    const [newUser, setNewUser] = useState({
        login_id: "",
        password: "",
        name: ""
    });
    const [idError, setIdError] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const token = sessionStorage.getItem("token");

    const handleInputChange = (login_id, field, value) => {
        setUsers(prev => prev.map(u =>
            u.login_id === login_id ? { ...u, [field]: value } : u
        ));
    };

    // 🛠️ 머스크 원칙에 입각해 부품(타이머)을 제거하고 논리만 남긴 함수
    const handleBlurOrEnter = (e, currentLoginId) => {
        // 엔터키 종료
        if (e.key === 'Enter') {
            setEditingId(null);
            return;
        }

        // 포커스를 잃었을 때(blur)
        if (e.type === 'blur') {
            // 관련 타겟(마우스가 새로 이동한 곳)이 여전히 현재 수정 중인 input 내부라면 닫지 않는다.
            if (e.relatedTarget && e.relatedTarget.className === "editable-input") {
                return; 
            }
            setEditingId(null);
        }
    };
    
    // 두 글자만 남기고 나머지는 *로 변환하는 함수
    const maskText = (text) => {
        if (!text) return "";
        if (text.length <= 2) return text; // 2글자 이하이면 그대로 표시
        return text.substring(0, 2) + "*".repeat(text.length - 2);
    };

    // --- 페이징 관련 상태 및 설정 ---
    const [currentPage, setCurrentPage] = useState(1); // 현재 페이지 (기본 1페이지)
    const ITEMS_PER_PAGE = 10; // 한 페이지당 보여줄 유저 수

    // [계산] 전체 페이지 수
    const totalPages = Math.ceil(users.length / ITEMS_PER_PAGE);

    // [계산] 현재 페이지에 해당하는 데이터만 잘라내기 (Slice)
    const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
    const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
    const currentUsers = users.slice(indexOfFirstItem, indexOfLastItem);

    // [함수] 페이지 변경 핸들러 (이동할 때 편집 모드를 안전하게 닫아줍니다)
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        setEditingId(null); // 페이지 이동 시 수정 중이던 상태 초기화
    };

    // --- 검색(조회) 관련 상태 ---
    const [searchTerm, setSearchTerm] = useState(""); // 입력 검색어 저장

    const fetchUsers = () => {

            const url = `${API_BASE_URL}/managers`;
            
            fetch(url, { 
                method: "POST",

                headers: { 
                    "Content-Type": "application/json",

                    Authorization: `Bearer ${token}` 
                }           
            
                , body: JSON.stringify({ searchTerm }) // 검색어를 JSON 형태로 전송
            })
            .then(res => {
                if (!res.ok) throw new Error(`서버 응답 오류: ${res.status}`);
                return res.json();
            })
            .then(data => {
                // console.log("응답 데이터:", data);  // 여기서 확인
                if (Array.isArray(data)) {
                    setUsers(data);                  // 상태 업데이트
                    //console.log("사용자 목록:", data);  // 사용자 목록 확인
                } else {
                    setUsers([]);                    // 배열이 아닐 경우 안전하게 빈 배열로
                }
            })
            .catch(err => {
                console.error("에러 발생:", err);  // 에러도 함께 확인
                setUsers([]);                     // 에러 시에도 빈 배열로 초기화
            });
        };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleUpdate = (login_id, field, value) => {
        const updated = users.map(u =>
            u.login_id === login_id ? { ...u, [field]: value } : u
        );
        setUsers(updated);

        const currentuserId = sessionStorage.getItem("userId")
        const payload = updated.find(u => u.login_id === login_id);
        payload.userId = currentuserId; // 수정하는 사람의 ID도 함께 전송

        fetch(`${API_BASE_URL}/managers/update`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        })
        .then(res => {
            if (!res.ok) throw new Error("수정 실패");
            return res.json();
        })
        .then(data => console.log("수정 성공:", data))
        .catch(err => console.error("수정 에러:", err));


    };


    return (
        <div>
            {/* [추가] 프로그램 제목 영역 */}
            <h2 style={{ marginBottom: "15px", color: "#333", borderBottom: "2px solid #333", paddingBottom: "10px" }}>
                🎓 관리자 계정 관리 
            </h2>

            {/* 상단 검색 바 및 컨트롤 버튼 */}
            <div className="search-bar" style={{ marginBottom: "15px", display: "flex", gap: "10px", alignItems: "center" }}>
                <input
                    type="text"
                    placeholder="ID 또는 이름 검색..."
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        //setCurrentPage(1); // 검색어 변경 시 1페이지로 이동
                    }}
                    style={{ padding: "8px", width: "250px", borderRadius: "4px", border: "1px solid #ccc" }}
                />
                {/* 검색 버튼 */}
                <button 
                    onClick={() => {fetchUsers(); setCurrentPage(1)}} // 현재 구조에서는 필터가 실시간 적용되므로 페이지 리셋 역할
                    style={{ 
                        padding: "8px 16px", 
                        backgroundColor: "#007bff", 
                        color: "#fff", 
                        border: "none", 
                        borderRadius: "4px", 
                        cursor: "pointer" 
                    }}
                >
                    검색
                </button>
                {/* 추가 버튼 */}
                <button 
                    onClick={() => {setNewUser({ login_id: "", password: "", name: "" });
                                    setIdError(""); setIsModalOpen(true);}} // 나중에 모달 오픈 함수나 페이지 이동 연결
                    style={{ 
                        padding: "8px 16px", 
                        backgroundColor: "#28a745", 
                        color: "#fff", 
                        border: "none", 
                        borderRadius: "4px", 
                        cursor: "pointer",
                        marginLeft: "auto" // 오른쪽 끝으로 배치하고 싶다면 유지, 왼쪽에 붙이려면 삭제
                    }}
                >
                    추가
                </button>
            </div>

            <table className="modern-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>이름</th>
                        <th>비밀번호</th>                        
                        <th>최근로그인</th>
                        <th>삭제</th>
                    </tr>
                </thead>
                <tbody>
                    {/* [변경 핵심] users.map 대신 현재 페이지 데이터인 currentUsers.map을 사용합니다. */}
                    {currentUsers.map((u, index) => (
                        <tr key={`${u.login_id}-${index}`}>                            
                            <td className="fixed-cell" readOnly>
                                {u.login_id}
                            </td>
                            <td>
                                <input
                                    className="editable-input"
                                    value={u.name}
                                    onChange={e => handleInputChange(u.login_id, "name", e.target.value)}
                                    onBlur={e => handleUpdate(u.login_id, "name", e.target.value)}
                                />
                            </td>
                            <td>
                                {/* 1. 팝업을 띄우기 위해 최외곽을 div로 감싸줍니다 */}
                                <div className="tooltip-container">
                                    
                                    <input
                                        type="text"
                                        className="editable-input"
                                        value={editingId === u.login_id ? (u.password || "") : (u.password || "")}
                                        placeholder={editingId === u.login_id ? "4글자 이상 입력" : "더블 클릭하여 수정"}
                                        readOnly={editingId !== u.login_id}
                                        onDoubleClick={() => setEditingId(u.login_id)}
                                        onKeyDown={handleBlurOrEnter}
                                        onChange={e => handleInputChange(u.login_id, "password", e.target.value)}
                                        onBlur={e => handleUpdate(u.login_id, "password", e.target.value)}
                                    />

                                    {/* 2. 편집 모드가 아닐 때만 "더블클릭시 변경" 팝업이 노출되도록 제어 */}
                                    {editingId !== u.login_id && (
                                        <span className="tooltip-text">더블클릭시 변경</span>
                                    )}
                                </div>
                            </td>
                                
                            <td>
                                <input
                                    className="uneditable-input"
                                    value={u.last_log || ''}
                                    readOnly
                                />
                            </td>
                            <td>
                                <select
                                    className="editable-select"
                                    value={u.state_fg}
                                    onChange={e =>
                                        handleUpdate(u.login_id, "state_fg", parseInt(e.target.value))
                                    }
                                >
                                    <option value={0}>정상</option>
                                    <option value={1}>삭제</option>
                                </select>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
                
            {/* --- 하단 페이징 네비게이션 버튼 바 --- */}
            {totalPages > 1 && (
                <div className="pagination-container">
                    {/* < 이전 버튼 */}
                    <button 
                        className="page-btn direction"
                        disabled={currentPage === 1}
                        onClick={() => handlePageChange(currentPage - 1)}
                    >
                        &lt;
                    </button>
            
                    {/* 페이지 번호 동적 생성 */}
                    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                        <button
                            key={page}
                            className={`page-btn ${currentPage === page ? "active" : ""}`}
                            onClick={() => handlePageChange(page)}
                        >
                            {page}
                        </button>
                    ))}

                    {/* > 다음 버튼 */}
                    <button 
                        className="page-btn direction"
                        disabled={currentPage === totalPages}
                        onClick={() => handlePageChange(currentPage + 1)}
                    >
                        &gt;
                    </button>
                </div>
            )}

            {/* [추가] 모달 컴포넌트 - 사용자 추가 폼 (간단한 예시) */}
            {isModalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        <h3>관리자 추가</h3>
                        <form autoComplete="off"
                              onSubmit={(e) => {
                            e.preventDefault(); 
                            
                            const currentId = (newUser?.login_id || "").trim();
                            const currentName = (newUser?.name || "").trim();
                            const currentPass = newUser?.password || "";
                            const currentuserId = sessionStorage.getItem("userId")   || "";
                            
                            if (!currentId || !currentName || !currentPass) {
                                alert("모든 필드를 입력해주세요.");
                                return;
                            }
                            if (currentPass.length < 4) {
                                alert("비밀번호는 4글자 이상이어야 합니다.");
                                return;
                            }
                            if (idError !== "사용 가능한 ID입니다.") {
                                alert("아이디 중복 체크를 완료해주세요.");
                                return;
                            }
                        
                            // 서버 전송용 데이터 구성
                            const payload = {
                                login_id: currentId,
                                name: currentName,
                                password: currentPass, 
                                userId: currentuserId
                            };
                            //console.log("전송할 데이터:", payload); // 전송 직전 데이터 확인
                        
                            fetch(`${API_BASE_URL}/managers/insert`, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${token}`
                                },
                                body: JSON.stringify(payload)
                            })
                            .then(res => {
                                if (!res.ok) throw new Error("사용자 등록 실패");
                                return res.json();
                            })
                            .then(() => {
                                alert("사용자가 등록되었습니다.");
                                setUsers(prev => [payload, ...(Array.isArray(prev) ? prev : [])]); 
                                setIsModalOpen(false); 
                                setNewUser({ login_id: "", password: "", name: "" }); // 초기화
                                setIdError(""); // 에러 메시지 초기화
                                // 컴포넌트 상단에 정의된 데이터 로드 함수명을 확인 후 입력하세요.
                                fetchUsers(); 
    
                            })
                            .catch(err => {
                                console.error("등록 에러:", err);
                                alert("등록 중 에러가 발생했습니다.");
                            });
                        }}>
                            {/* 1. 로그인 ID 입력 및 중복 체크 버튼 */}
                            <div style={{ marginBottom: "12px" }}>
                                <label style={{ display: "block", marginBottom: "4px", fontWeight: "bold", fontSize: "12px" }}>아이디(ID)</label>
                                <div style={{ display: "flex", gap: "8px", alignItems: "center", width: "100%" }}>
                                    <input
                                        type="text"
                                        placeholder="로그인 ID"
                                        autoComplete="one-time-code" 
                                        value={newUser?.login_id || ""}
                                        onChange={e => {
                                            setNewUser(prev => ({ ...prev, login_id: e.target.value }));
                                            setIdError(""); // 아이디를 다시 타이핑하면 중복 체크 상태 리셋
                                        }}
                                        style={{ 
                                                  width: "70%",
                                                  padding: "10px 12px",     // 💡 여백을 줘서 입력창을 시원하게 만듭니다
                                                  boxSizing: "border-box",
                                                  border: "1px solid #ccc",  // 💡 연하고 깔끔한 회색 테두리
                                                  borderRadius: "4px",       // 💡 부드러운 둥근 모서리
                                                  fontSize: "14px",          // 💡 글자 크기를 14픽셀로 통일
                                                  height: "40px"             // 💡 전체 세로 높이를 40픽셀로 딱 고정
                                              }}
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => {
                                            const currentId = (newUser?.login_id || "").trim();
                                            if (!currentId) {
                                                alert("ID를 입력한 후 중복 체크를 해주세요.");
                                                return;
                                            }
                                        
                                            // 백엔드로 ID 중복 체크 요청전송 (POST 방식 가정)
                                            fetch(`${API_BASE_URL}/managers/idcheck`, {
                                                method: "POST",
                                                headers: {
                                                    "Content-Type": "application/json",
                                                    Authorization: `Bearer ${token}`
                                                },
                                                body: JSON.stringify({ login_id: currentId })
                                            })
                                            .then(res => {
                                                if (!res.ok) {
                                                    throw new Error("서버 응답 실패");
                                                }
                                                return res.json(); // 단 한 번만 리턴
                                            })
                                            .then(data => {
                                                if (data.isDuplicate) {
                                                    setIdError("이미 존재하는 ID입니다.");
                                                } else {
                                                    setIdError("사용 가능한 ID입니다.");
                                                }
                                            })
                                            .catch(err => {
                                                console.error("ID 체크 에러:", err);
                                                alert("중복 체크 중 오류가 발생했습니다.");
                                            });
                                        }}
                                        style={{ 
                                            padding: "10px 16px",     // 개발자 도구에 있던 패딩 유지
                                            height: "38px",          // 인풋창과 동일한 높이 지정으로 상하 대칭 정렬
                                            backgroundColor: "#495057", 
                                            color: "#fff", 
                                            border: "none", 
                                            borderRadius: "4px", 
                                            cursor: "pointer"
                                            // ❌ 기존 스타일에 있던 margin-left: "auto" 속성은 삭제해 주세요!
                                        }}
                                    >
                                        중복 체크
                                    </button>
                                </div>
                                {idError && (
                                    <span style={{ fontSize: "11px", display: "block", marginTop: "4px", color: idError === "사용 가능한 ID입니다." ? "green" : "red" }}>
                                        {idError}
                                    </span>
                                )}
                            </div>
                            
                            {/* 2. 이름 입력 */}
                            <div style={{ marginBottom: "12px" }}>
                                <label style={{ display: "block", marginBottom: "4px", fontWeight: "bold", fontSize: "12px" }}>이름</label>
                                <input
                                    type="text"
                                    placeholder="이름"
                                    value={newUser?.name || ""}
                                    onChange={e => setNewUser(prev => ({ ...prev, name: e.target.value }))}
                                        style={{ 
                                                  width: "100%", 
                                                  padding: "10px 12px",     // 💡 여백을 줘서 입력창을 시원하게 만듭니다
                                                  boxSizing: "border-box",
                                                  border: "1px solid #ccc",  // 💡 연하고 깔끔한 회색 테두리
                                                  borderRadius: "4px",       // 💡 부드러운 둥근 모서리
                                                  fontSize: "14px",          // 💡 글자 크기를 14픽셀로 통일
                                                  height: "40px"             // 💡 전체 세로 높이를 40픽셀로 딱 고정
                                              }}
                                    required
                                />
                            </div>
                                          
                            {/* 3. 비밀번호 입력 */}
                            <div style={{ marginBottom: "20px" }}>
                                <label style={{ display: "block", marginBottom: "4px", fontWeight: "bold", fontSize: "12px" }}>비밀번호</label>
                                <input
                                    type="password"
                                    placeholder="비밀번호 (4자 이상)"
                                    autoComplete="new-password"
                                    value={newUser?.password || ""}
                                    onChange={e => setNewUser(prev => ({ ...prev, password: e.target.value }))}
                                        style={{ 
                                                  width: "100%", 
                                                  padding: "10px 12px",     // 💡 여백을 줘서 입력창을 시원하게 만듭니다
                                                  boxSizing: "border-box",
                                                  border: "1px solid #ccc",  // 💡 연하고 깔끔한 회색 테두리
                                                  borderRadius: "4px",       // 💡 부드러운 둥근 모서리
                                                  fontSize: "14px",          // 💡 글자 크기를 14픽셀로 통일
                                                  height: "40px"             // 💡 전체 세로 높이를 40픽셀로 딱 고정
                                              }}
                                    required
                                />
                            </div>
                                          
                            {/* 버튼 제어 */}
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                                <button type="submit" disabled={idError !== "사용 가능한 ID입니다."}
                                style={{ 
                                            backgroundColor: idError === "사용 가능한 ID입니다." ? "#007bff" : "#6c757d",
                                            color: "#fff", 
                                            border: "none", 
                                            borderRadius: "4px", 
                                            cursor: "pointer"
                                        }}
                                >저장</button>
                                <button type="button" onClick={() => {
                                    setIsModalOpen(false);
                                    setNewUser({ login_id: "", password: "", name: "" }); 
                                    setIdError("");
                                }}
                                style={{ 
                                            backgroundColor: "#e44d4d", 
                                            color: "#fff", 
                                            border: "none", 
                                            borderRadius: "4px", 
                                            cursor: "pointer"
                                        }}>
                                    취소
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}



        </div>

    );
}

export default ManagerList;